import AppPage from './AppPage';

export default AppPage;